export const DEMO_MAX_USERS = 10;

export const LICENSE_VERTICALS = [
  { value: 'distribution', label: 'Distribution' },
  { value: 'retail', label: 'Retail' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'hospitality', label: 'Hospitality' },
  { value: 'port', label: 'Port' },
];

export function normalizePrimaryVertical(value) {
  const vertical = String(value || 'distribution').toLowerCase();
  return LICENSE_VERTICALS.some((item) => item.value === vertical) ? vertical : 'distribution';
}

export function addDaysIso(dateIso, days) {
  const d = new Date(dateIso || Date.now());
  d.setDate(d.getDate() + days);
  return d.toISOString().split('T')[0];
}

export function isLicenseExpired(license) {
  if (!license) return false;
  if (license.status === 'expired' || license.status === 'cancelled') return true;
  if (!license.expiry_date) return false;
  const expiry = new Date(license.expiry_date);
  expiry.setHours(23, 59, 59, 999);
  return expiry < new Date();
}

export function formatLicensePeriod(license) {
  if (!license?.start_date && !license?.expiry_date) return '—';
  const start = license.start_date ? new Date(license.start_date).toLocaleDateString() : '—';
  const end = license.expiry_date ? new Date(license.expiry_date).toLocaleDateString() : '—';
  return `${start} → ${end}`;
}
